/* B2Ctelecom – Combineer en bespaar: hoesje + aangevinkte accessoires in één /cart/add.js-verzoek (publicatiekandidaat 02-11-2026).
   Zelfde logica als getest in testthema 189117563113 (assets/b2c-koop.js, md5 c5c21348…), aangepast aan de
   live-snippet product-upsell.liquid (checkboxes .upsell-product--checkbox met form="<product_form_id>").
   - Alleen als minstens één accessoire is aangevinkt; anders blijft de normale koopknop 100% ongewijzigd.
   - Niet op Customily-pagina's (#customily-cart-btn aanwezig) -> normale/Customily-flow blijft.
   - Eén JSON-verzoek naar /cart/add.js; géén eigen trackingcode of events.
   Verwijderen = rollback (scriptregel in snippets/product-upsell.liquid weghalen + dit bestand). */
(function () {
  if (window.__b2cCombiAdd) return; window.__b2cCombiAdd = true;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var formId = form.getAttribute('id'); // let op: form.id kan het veld name="id" zijn
    if (!formId || !form.closest('product-form')) return;
    if (document.querySelector('#customily-cart-btn')) return;
    var sel = Array.prototype.slice.call(document.querySelectorAll('input.upsell-product--checkbox[form="' + formId + '"]:checked'));
    if (!sel.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var pf = form.closest('product-form');
    var btn = pf.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    var fd = new FormData(form);
    var main = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 };
    var props = {};
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && typeof v === 'string') props[m[1]] = v; });
    if (Object.keys(props).length) main.properties = props;
    if (fd.get('selling_plan')) main.selling_plan = fd.get('selling_plan');
    var items = [main].concat(sel.map(function (i) { return { id: parseInt(i.value, 10), quantity: 1 }; }));
    var cartEl = document.querySelector('cart-drawer');
    var body = { items: items };
    if (cartEl && cartEl.getSectionsToRender) { body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
    var spin = pf.querySelector('.loading__spinner');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    if (spin) spin.classList.remove('hidden');
    function done() { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } if (spin) spin.classList.add('hidden'); }
    if (pf.handleErrorMessage) pf.handleErrorMessage();
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { done(); if (pf.handleErrorMessage) pf.handleErrorMessage(res.description || res.message); return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: String(main.id), cartData: res }); } catch (x) {} }
        done();
        if (cartEl && cartEl.renderContents && res.sections) { cartEl.classList.remove('is-empty'); cartEl.renderContents(res); }
        else { location.href = (window.routes && routes.cart_url) || '/cart'; }
      })
      .catch(function () { done(); location.href = (window.routes && routes.cart_url) || '/cart'; }); // geen herhaalverzoek
  }, true);
})();
